export const LEARNED_ROUTES_AVAILABLE_CODE = 'learned_routes_available';

/**
 * Missing account setting means learned routes are enabled (opt-out).
 */
export function isLearnedRoutesAvailable(
  accountSettings: Record<string, unknown> | null | undefined,
): boolean {
  if (accountSettings == null) {
    return true;
  }
  if (!Object.prototype.hasOwnProperty.call(
    accountSettings,
    LEARNED_ROUTES_AVAILABLE_CODE,
  )) {
    return true;
  }
  const value = accountSettings[LEARNED_ROUTES_AVAILABLE_CODE];
  return !!+String(value);
}
